import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { METRIKA_ID_NUM } from '@/lib/siteConfig';

/**
 * Yandex.Metrika SPA hit tracker.
 * Sends `ym('hit', url)` on every react-router-dom route change.
 * The base counter script is injected in public/index.html.
 *
 * Просмотр страницы входа отправляет сам index.html — с адресом, снятым до
 * загрузки React (window.__ymLanding), вместе с utm-метками. Здесь его не
 * повторяем: первый прогон эффекта пропускается, если адрес не изменился.
 * Если адрес успел смениться (клиентский редирект), шлём новый просмотр,
 * а рефером ставим адрес входа. Для переходов по сайту рефер — предыдущая
 * страница, а не внешний document.referrer.
 */
const YM_ID = METRIKA_ID_NUM;

export default function YandexMetrikaTracker() {
  const location = useLocation();
  const prevUrl = useRef(null);

  useEffect(() => {
    if (!YM_ID || typeof window === 'undefined' || typeof window.ym !== 'function') return;
    const url = window.location.href;
    const landing = window.__ymLanding && window.__ymLanding.url;
    const referer = prevUrl.current || landing || document.referrer || undefined;
    const isFirstRun = prevUrl.current === null;
    prevUrl.current = url;
    if (isFirstRun && landing && url === landing) return;
    try {
      window.ym(YM_ID, 'hit', url, {
        referer,
        title: document.title,
      });
    } catch (_) {
      // silent — analytics must never break UX
    }
  }, [location.pathname, location.search, location.hash]);

  return null;
}
